import React, { useState } from "react";
import styles from "./Navbar.module.css";
import { COMPANY_NAME, WHATSAPP_LINK } from "../siteData";

const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why-us" },
  { label: "Gallery", href: "#gallery" },
  { label: "About Us", href: "#about" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className={styles.header}>
      <nav className={`container ${styles.nav}`}>
        <a href="#home" className={styles.brand} onClick={() => setOpen(false)}>
          <span className={styles.brandMark}>JC</span>
          <span className={styles.brandName}>{COMPANY_NAME}</span>
        </a>

        <button
          className={styles.toggle}
          aria-label="Toggle navigation menu"
          aria-expanded={open}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span className={styles.toggleBar} />
          <span className={styles.toggleBar} />
          <span className={styles.toggleBar} />
        </button>

        <div className={`${styles.links} ${open ? styles.linksOpen : ""}`}>
          <ul className={styles.linkList}>
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a href={link.href} onClick={() => setOpen(false)}>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className={`jc-btn jc-btn-primary ${styles.navCta}`}
          >
            WhatsApp Us
          </a>
        </div>
      </nav>
    </header>
  );
}
